import {dbParent, insertMultiple, listAllCollection, listAllCollectionSub} from './utils';
import firebase from 'firebase';
import dayjs from 'dayjs';
import {createUser} from './users';



export const projectSchema = {
  jobs: null,
  versions: {
    objects: null,
    jobs: null,
    dirs: null,
    works_type: null,
  },
  plan: {
    objects: null,
    jobs: null,
    dirs: null,
    works_type: null,
  },
  tasks: null,
  dirs: null,
  objects: null,
  inputs: {
    objects: null,
  },
  zones: {
    objects: null
  },
  'tasks-categories': null,
  documentation: null,
  files: null,
  works_type: null,
  reports: null,
  units: null,
  inch: null
}

export const getDemoProject = async () => {
  const subDoc = await dbParent().doc('kJxJKKbGdRxwIhHrBdnq').get();
  const projects = [];
  let project_id = null;

  // await response.forEach((subDoc) => {
    projects.push({...subDoc.data()});
    project_id = subDoc.id;
  // });

  return {
    project: projects[0],
    project_id,
  };
};



export const getSchema = async () => {
  const db = firebase.firestore();

  function replaceIdsInData(data, idMapping) {
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === 'object' && value !== null) {
        replaceIdsInData(value, idMapping);
      } else if (idMapping.hasOwnProperty(value)) {
        data[key] = idMapping[value];
      }
    }
  }

  async function copyDocumentAndNestedCollections(sourceRef, targetRef, idMapping, subcollections, isMain, batch) {
    const docSnapshot = await sourceRef.get();
    const docData = docSnapshot.data();

    replaceIdsInData(docData, idMapping);

    if (!isMain) {
      batch.set(targetRef, docData);
    }

    if (subcollections) {
      const subcollectionPromises = [];
      for (const [subcollection, nestedSubcollections] of Object.entries(subcollections)) {
        const querySnapshotPromise = sourceRef.collection(subcollection).get();
        subcollectionPromises.push(querySnapshotPromise.then(async (querySnapshot) => {
          const docPromises = [];
          for (const doc of querySnapshot.docs) {
            const newDocRef = targetRef.collection(subcollection).doc();
            idMapping[doc.id] = newDocRef.id;
            const docPromise = copyDocumentAndNestedCollections(doc.ref, newDocRef, idMapping, nestedSubcollections, false, batch);
            docPromises.push(docPromise);
          }
          await Promise.all(docPromises);
        }));
      }
      await Promise.all(subcollectionPromises);
    }
  }

  async function copyDocumentById(collection, sourceDocId, targetDocId, subcollections) {
    const idMapping = {};
    const sourceRef = db.collection(collection).doc(sourceDocId);
    const targetRef = db.collection(collection).doc(targetDocId);
    const batch = db.batch();

    await copyDocumentAndNestedCollections(sourceRef, targetRef, idMapping, subcollections, true, batch);
    await batch.commit();
  }

  const {project, project_id} = await getDemoProject();
  const create_demo = await createDemo(project);
  const collection = "projects";
  const sourceDocId = project_id;
  const targetDocId = create_demo.id;


  const projectCollection = dbParent().doc(create_demo.id);

  (async () => {
    const users = await listAllCollection('users', sourceDocId);

    await insertMultiple(
      users.filter((user) => user.isDemo === true),
      projectCollection.collection('users'),
    );
  })();


  const subcollections = {
    jobs: null,
    versions: {
      objects: null,
      jobs: null,
      dirs: null,
      works_type: null,
    },
    plan: {
      objects: null,
      jobs: null,
      dirs: null,
      works_type: null,
    },
    tasks: null,
    dirs: null,
    objects: null,
    inputs: {
      objects: null,
    },
    zones: {
      objects: null,
    },
    'tasks-categories': null,
    documentation: null,
    files: null,
    works_type: null,
    reports: null,
    units: null,
    inch: null,
  };

  try {
    await copyDocumentById(collection, sourceDocId, targetDocId, subcollections)
    return create_demo;
  } catch (error) {
    console.error("Error copying document and nested collections:", error);
    return false;
  }
}

const createDemo = async (data) => {
  const currentUser = firebase.auth().currentUser;

  const id =  await firebase.firestore().collection('projects').add({
    ...data,
    isDemo: false,
    owner: currentUser.uid,
    start_date: dayjs(dayjs().utc().format('YYYY-MM-DD')).unix(),
    end_date: dayjs(dayjs().utc().add(14, 'days').format('YYYY-MM-DD')).unix(),
    rules: {
      [currentUser.uid]: 'admin',
    },
  });

  return {
    id: id.id,
    ...data,
    isDemo: false,
    owner: currentUser.uid,
    start_date: dayjs(dayjs().utc().format('YYYY-MM-DD')).unix(),
    end_date: dayjs(dayjs().utc().add(14, 'days').format('YYYY-MM-DD')).unix(),
    rules: {
      [currentUser.uid]: 'admin',
    },
  }
};

export const getDemoUser = async (id) => {
  try {
    let result = null;

    const response = await firebase.firestore().collection('userStat')
      .where(`uid`, '==', id).get();

    response.forEach((sub) => {
      result = sub.data()
    });


    return result || {};
  } catch (e) {
    return  {
      name: '',
      phone: '',
      company: '',
    }
  }
};



// WEBPACK FOOTER //
// ./src/firestore/demo.js